import LoginDesign01 from "./LoginDesign01";
import LoginDesign02 from "./LoginDesign02";
import LoginDesign03 from "./LoginDesign03";
import LoginDesign04 from "./LoginDesign04";
import LoginDesign05 from "./LoginDesign05";
import LoginDesign06 from "./LoginDesign06";
import LoginDesign07 from "./LoginDesign07";
import LoginDesign08 from "./LoginDesign08";
import LoginDesign09 from "./LoginDesign09";
import LoginDesign10 from "./LoginDesign10";
import LoginDesign11 from "./LoginDesign11";
import LoginDesign12 from "./LoginDesign12";
import LoginDesign13 from "./LoginDesign13";
import LoginDesign14 from "./LoginDesign14";
import LoginDesign15 from "./LoginDesign15";
import LoginDesign16 from "./LoginDesign16";
import { useNavigate, useLocation } from "react-router-dom";

const designs = {
  1: LoginDesign01,
  2: LoginDesign02,
  3: LoginDesign03,
  4: LoginDesign04,
  5: LoginDesign05,
  6: LoginDesign06,
  7: LoginDesign07,
  8: LoginDesign08,
  9: LoginDesign09,
  10: LoginDesign10,
  11: LoginDesign11,
  12: LoginDesign12,
  13: LoginDesign13,
  14: LoginDesign14,
  15: LoginDesign15,
  16: LoginDesign16,
};

export const LOGIN_DESIGN_NUMBERS = Object.keys(designs).map(Number);

// Floating 1–16 switcher, bottom-right
const DesignSwitcher = ({ current }) => {
  const navigate = useNavigate();
  return (
    <div style={{ position: "fixed", right: 16, bottom: 16, zIndex: 2000, display: "flex", gap: 4, flexWrap: "wrap", justifyContent: "flex-end", maxWidth: "calc(100vw - 32px)", padding: 6, borderRadius: 12, background: "rgba(15,23,42,.88)", backdropFilter: "blur(8px)", boxShadow: "0 8px 24px rgba(0,0,0,.25)", fontFamily: "system-ui, sans-serif", }} >
      {LOGIN_DESIGN_NUMBERS.map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => navigate(`/${n}`)}
          aria-label={`Login design ${n}`}
          aria-current={n === current ? "page" : undefined}
          style={{
            width: 30,
            height: 30,
            border: 0,
            borderRadius: 8,
            cursor: "pointer",
            fontSize: 13,
            fontWeight: 600,
            color: n === current ? "#0f172a" : "#e2e8f0",
            background: n === current ? "#fff" : "transparent",
          }}
        >
          {n}
        </button>
      ))}
    </div>
  );
};

// Used by routes /1 … /16
const LoginDesignPage = ({ connectionString }) => {
  const { pathname } = useLocation();
  const n = Number(pathname.replace("/", ""));
  const Design = designs[n];
  if (!Design) return null;
  return (
    <>
      <Design connectionString={connectionString} />
      <DesignSwitcher current={n} />
    </>
  );
};

export default LoginDesignPage;
